var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctor1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 0.5,
    width: 60,
    height: 60,
    rx: 7,
    fill: "#005587"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4986 30.0101C37.1667 30.0002 42.5 35.3335 42.5 40.6668C42.5 41.7039 41.6934 41.9343 41.3349 41.9855L41.1667 42.0002L19.7876 41.9983L19.6651 41.9855C19.3066 41.9343 18.5 41.7039 18.5 40.6668C18.5 35.3335 23.8333 30.0002 30.4986 30.0101ZM31.3333 32.6668H29.6667C29.3905 32.6668 29.1667 32.8907 29.1667 33.1668V35.3335H27C26.7239 35.3335 26.5 35.5574 26.5 35.8335V37.5002C26.5 37.7763 26.7239 38.0002 27 38.0002H29.1667V40.1668C29.1667 40.443 29.3905 40.6668 29.6667 40.6668H31.3333C31.6095 40.6668 31.8333 40.443 31.8333 40.1668V38.0002H34C34.2761 38.0002 34.5 37.7763 34.5 37.5002V35.8335C34.5 35.5574 34.2761 35.3335 34 35.3335H31.8333V33.1668C31.8333 32.8907 31.6095 32.6668 31.3333 32.6668ZM30.5 15.3335C34.1819 15.3335 37.1667 18.3183 37.1667 22.0002C37.1667 25.6821 34.1819 28.6668 30.5 28.6668C26.8181 28.6668 23.8333 25.6821 23.8333 22.0002C23.8333 18.3183 26.8181 15.3335 30.5 15.3335Z",
    fill: "#80AAC3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor1);
export default __webpack_public_path__ + "static/media/doctor-1.719620bb.svg";
export { ForwardRef as ReactComponent };